export const FILTER_NOTIFICATION_STREAMS =
  'eventDetails/FILTER_NOTIFICATION_STREAMS';
export const RESET_FILTERS = 'RESET_FILTERS';

export const GET_NOTIFICATION_STREAMS = 'eventDetails/GET_NOTIFICATION_STREAMS';
export const GET_NOTIFICATION_STREAMS_START = `${GET_NOTIFICATION_STREAMS}_START`;
export const GET_NOTIFICATION_STREAMS_SUCCESS = `${GET_NOTIFICATION_STREAMS}_SUCCESS`;
export const GET_NOTIFICATION_STREAMS_FAIL = `${GET_NOTIFICATION_STREAMS}_FAIL`;

export const SET_NOTIFICATION_STREAMS = 'eventDetails/SET_NOTIFICATION_STREAMS';
export const SET_NOTIFICATION_STREAMS_FAIL = `${SET_NOTIFICATION_STREAMS}_FAIL`;

export const SET_ACTIVE_NOTIFICATION_STREAMS_FILTERS =
  'eventDetails/SET_ACTIVE_NOTIFICATION_STREAMS_FILTER';

export function getNotificationStreams({ planId, uri = `/webapi/xm/1/plans` }) {
  return {
    type: GET_NOTIFICATION_STREAMS,
    meta: {
      xmApi: true,
      method: 'get',
      uri: `${uri}/${planId}/subscription-forms`,
      sortBy: 'NAME',
    },
  };
}

export function setNotificationStreams(notificationStreams) {
  return {
    type: SET_NOTIFICATION_STREAMS,
    payload: notificationStreams,
  };
}

export function setNotificationStreamsFilter(notificationStreamsFilter) {
  return {
    type: FILTER_NOTIFICATION_STREAMS,
    payload: notificationStreamsFilter,
  };
}

export function setActiveNotificationStreamsFilter(
  activeNotificationStreamsFilter,
) {
  return {
    type: SET_ACTIVE_NOTIFICATION_STREAMS_FILTERS,
    payload: activeNotificationStreamsFilter,
  };
}

export function resetFilters() {
  return {
    type: RESET_FILTERS,
  };
}
